var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovingBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7167 2.28333L8.73333 5.25C8.34444 5.63889 7.87222 5.83333 7.31667 5.83333C6.76111 5.83333 6.28889 5.63889 5.9 5.25L5.11667 4.46667C4.99444 4.34444 4.83889 4.28333 4.65 4.28333C4.46111 4.28333 4.30556 4.34444 4.18333 4.46667L1.11667 7.53333C0.994444 7.65556 0.838889 7.71667 0.65 7.71667C0.461111 7.71667 0.305556 7.65556 0.183333 7.53333C0.0611111 7.41111 0 7.25556 0 7.06667C0 6.87778 0.0611111 6.72222 0.183333 6.6L3.25 3.53333C3.63889 3.14444 4.11111 2.95 4.66667 2.95C5.22222 2.95 5.69444 3.14444 6.08333 3.53333L6.85 4.3C6.98333 4.43333 7.14167 4.5 7.325 4.5C7.50833 4.5 7.66667 4.43333 7.8 4.3L10.7667 1.33333H9.71667C9.52778 1.33333 9.36944 1.26944 9.24167 1.14167C9.11389 1.01389 9.05 0.855556 9.05 0.666667C9.05 0.477778 9.11389 0.319444 9.24167 0.191667C9.36944 0.0638889 9.52778 0 9.71667 0H12.3833C12.5722 0 12.7306 0.0638889 12.8583 0.191667C12.9861 0.319444 13.05 0.477778 13.05 0.666667V3.33333C13.05 3.52222 12.9861 3.68056 12.8583 3.80833C12.7306 3.93611 12.5722 4 12.3833 4C12.1944 4 12.0361 3.93611 11.9083 3.80833C11.7806 3.68056 11.7167 3.52222 11.7167 3.33333V2.28333Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingBlack);
export default __webpack_public_path__ + "static/media/moving_black.154b0eaa60c06e8d171de74f5d5830b5.svg";
export { ForwardRef as ReactComponent };